export const hasIncompleteAssets = (r, blacklist) => {
  if (!r || typeof r !== 'object') return false
  const bl = normalizeBlacklist(blacklist)
  return Object.values(r)
    .filter(Boolean)
    .map((c) => safeParseAtivos(c.ativos))
    .some(
      (ativos) =>
        Array.isArray(ativos) &&
        ativos.some((a) => isIncompleteNotBlacklisted(a, bl))
    )
}

export const normalizeBlacklist = (list) =>
  Array.isArray(list)
    ? list
        .filter((v) => typeof v === 'string')
        .map((v) => v.toLowerCase().trim())
    : []

export const safeParseAtivos = (ativos) => {
  if (Array.isArray(ativos)) return ativos
  if (ativos && typeof ativos === 'object') return Object.values(ativos)
  if (typeof ativos === 'string') {
    try {
      const parsed = JSON.parse(ativos)
      return Array.isArray(parsed)
        ? parsed
        : parsed && typeof parsed === 'object'
        ? Object.values(parsed)
        : []
    } catch (e) {
      return []
    }
  }
  return []
}

export const isIncompleteNotBlacklisted = (a, blacklistLower) => {
  if (!a || !a.campos_faltantes) return false
  const tipo = getAssetTypeLower(a)
  if (!tipo) return false
  return blacklistLower.indexOf(tipo) === -1
}

export const getAssetTypeLower = (a) => {
  const t =
    a && typeof a === 'object'
      ? typeof a.Tipo === 'string'
        ? a.Tipo
        : a.tipo
      : ''
  return typeof t === 'string' ? t.toLowerCase().trim() : ''
}
